const MIME_TYPES_BY_EXTENSION: Record<string, string> = {
  pdf: "application/pdf",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  heic: "image/heic",
  heif: "image/heif",
  mp4: "video/mp4",
  mov: "video/quicktime",
};

const getExtension = (name = "") => {
  const cleanName = name.split(/[?#]/)[0];
  const extension = cleanName.split(".").pop();
  return extension && extension !== cleanName ? extension.toLowerCase() : "";
};

export const getFileContentType = (file: Pick<File, "name" | "type">) =>
  file.type?.toLowerCase() ||
  MIME_TYPES_BY_EXTENSION[getExtension(file.name)] ||
  "application/octet-stream";

export const isPdfFile = (file: Pick<File, "name" | "type">) =>
  file.type?.toLowerCase() === "application/pdf" ||
  getExtension(file.name) === "pdf";

export const isImageFile = (file: Pick<File, "name" | "type">) => {
  const type = file.type?.toLowerCase();
  return (
    type?.startsWith("image/") ||
    ["jpg", "jpeg", "png", "gif", "webp", "heic", "heif"].includes(
      getExtension(file.name)
    )
  );
};

export const isMp4File = (file: Pick<File, "name" | "type">) =>
  file.type?.toLowerCase() === "video/mp4" || getExtension(file.name) === "mp4";

export const isIOSWebKit = () => {
  if (typeof navigator === "undefined") return false;

  return (
    /iPad|iPhone|iPod/i.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
};

export const getObjectKeyFromPresignedUrl = (presignedUrl: string) => {
  try {
    return new URL(presignedUrl).pathname.replace(/^\/+/, "");
  } catch {
    return presignedUrl.split("?")[0];
  }
};

export const normalizeFileName = (name = "") => name.normalize("NFC");

export const resolveAssetUrl = (assetUrl: string, cdnBaseUrl: string) => {
  if (!assetUrl || /^(https?:|blob:|data:)/i.test(assetUrl)) return assetUrl;
  if (assetUrl.startsWith("//"))
    return `${window.location.protocol}${assetUrl}`;

  return `${cdnBaseUrl.replace(/\/$/, "")}/${assetUrl.replace(/^\//, "")}`;
};
